import Vue from 'vue';
import Vuex from 'vuex';

import stocksAutocompleteSearch from '@/store/stocksAutocompleteSearch';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {
    },
    modules: {

      stocksAutocompleteSearch,
    },
  });
};
